import React from 'react';
import PropTypes from 'prop-types';
import styles from './Hero.module.scss';
import Image from '../../components/Image';

const Hero = ({ image }) =>
    image && (
        <div className={styles['Hero']}>
            <div className={styles['Hero__Container']}>
                <Image {...image} />
            </div>
        </div>
    );

Hero.propTypes = {
    image: PropTypes.object,
};

Hero.defaultProps = {
    image: {},
};

export default Hero;
